// extracted by mini-css-extract-plugin
export default {"reactMarkDown":"markdown_styles_reactMarkDown__uOlrk"};